import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    items:[],
}
const cartReducer = createSlice({
    name: "cartReducer",
    initialState,
    reducers: {
        addToCart:(state, action)=>{
            //action payload = du lieu tra ve tu User
            let isProductExists = false;
            //SP da ton tai trong Gio hang
            state.items.map((item)=>{
                if(item._id===action.payload._id){
                    item.qty += Number(action.payload.qty);//ép kiểu khi user nhập qty vào từ form
                    isProductExists = true;
                }
                return item;
            });
            //SP chua ton tai trong Gio hang
            if(!isProductExists){
                state.items.push(action.payload);
            }
        },
        updateCart: (state, action)=>{
            const newItems = state.items.map((item)=>{ //xu ly bat dong bo khuyen khich tao ra newItems trong mot so truong hop
                if(item._id===action.payload._id){
                    item.qty = Number(action.payload.qty);
                }
                return item;
            });
        },
        deleteItemCart: (state, action)=>{
                //xu ly đồng bộ
                const newItems = state.items.filter((item)=>item._id!==action.payload._id);
                state.items = newItems;
                //viết gọn lại như thế này thì là xử lý bất đồng bộ-->ko chạy được: 
                //state.items.filter((item)=>item._id!==action.payload._id);
        },
        resetCart: (state, action)=>{
            state.items = [];
        }
        },
    }
);
export const {addToCart, updateCart, deleteItemCart, resetCart} = cartReducer.actions;
export default cartReducer.reducer;